import { render } from "./supports.vue?vue&type=template&id=458ac553&scoped=true"
import script from "./supports.vue?vue&type=script&lang=js"
export * from "./supports.vue?vue&type=script&lang=js"

import "./supports.vue?vue&type=style&index=0&id=458ac553&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-458ac553"

export default script